import { Drawer as DrawerBox, useDrawersStack as useDrawersStackHook } from '@mantine/core';

export const Drawer = DrawerBox;
export const useDrawersStack = useDrawersStackHook;
